export type ReviewableSetting={Secret:boolean;configured:boolean}

const secretKeyPattern=/(?:API_KEY|PASSWORD|PRIVATE_KEY|SECRET|TOKEN)/i

export function settingReviewValue(key:string,item:ReviewableSetting|undefined,value:string|null):string{
  if(value===null)return '恢复环境值'
  if(item?.Secret||secretKeyPattern.test(key)){
    if(value==='')return '清空密钥（内容已隐藏）'
    return item?.configured?'轮换密钥（内容已隐藏）':'配置密钥（内容已隐藏）'
  }
  return value||'空值'
}
